// extracted by mini-css-extract-plugin
export var bounce = "style-module--bounce--dbbbd";
export var column = "style-module--column--6ae43";
export var dot = "style-module--dot--0f8d6";
export var logo = "style-module--logo--c27e7";
export var row = "style-module--row--57102";
export var table = "style-module--table--5da17";
export var th = "style-module--th--9fd77";